export function stepLabel(step, occ) {
  if (step === 'despacha') {
    return occ && occ.dispatches_count > 0 ? 'Despachado' : 'Ag. Despacho'
  }
  const labels = { regulacao: 'Atendimento' }
  return labels[step] || step || '—'
}
